import Hook from "../utils/hook"

export default Hook(`ShareModal`, {
  values: { url: String, urlCopied: Boolean },
  targets: [`urlInput`, `urlButton`],
  actions: [
    {
      name: `selectUrlInputText`,
      target: `urlInput`,
      type: `focus`,
    },
    {
      name: `copyUrlToClipboard`,
      target: `urlButton`,
      type: `click`,
    },
  ],

  copyUrlToClipboardAction() {
    window.navigator.clipboard.writeText(this.urlValue)
    this.urlCopiedValue = true
    window.setTimeout(() => (this.urlCopiedValue = false), 2000)
  },

  selectUrlInputTextAction() {
    this.urlInputTarget.select()
  },
})
